export default __webpack_public_path__ + "static/media/Linkedin.117fc49a.svg";